import React from "react";
import { AlertTriangle } from "lucide-react";

const STYLES = {
  ACTIVE:     { pill: "bg-emerald-100 text-emerald-800 border-emerald-200", dot: "bg-emerald-500" },
  SUSPENDED:  { pill: "bg-amber-100 text-amber-800 border-amber-200",       dot: "bg-amber-500"   },
  TERMINATED: { pill: "bg-red-100 text-red-900 border-red-300",             dot: "bg-red-700"     },
};

export const StatusPill = ({ status, size = "sm", testId }) => {
  const s = String(status || "").toUpperCase();
  const style = STYLES[s] || STYLES.ACTIVE;
  const px = size === "lg" ? "px-3 py-1 text-[12px]" : "px-2.5 py-0.5 text-[11px]";
  return (
    <span
      data-testid={testId || `status-pill-${s.toLowerCase()}`}
      className={`inline-flex items-center gap-1.5 rounded-full ${px} font-bold uppercase tracking-wider border ${style.pill}`}
    >
      <span className={`inline-block h-1.5 w-1.5 rounded-full ${style.dot}`} />
      {s}
    </span>
  );
};

export const FlagBadge = ({ note }) => (
  <span
    title={note || "Flagged for review"}
    className="inline-flex items-center gap-1 rounded-full border border-amber-200 bg-amber-100 px-2 py-0.5 text-[10px] font-bold uppercase tracking-wider text-amber-800"
  >
    <AlertTriangle size={12} strokeWidth={2.5} />
    Review
  </span>
);
